const sanityConfig = () => ({
    projectId: "4swbd7aj",
    dataset: process.env.GATSBY_SANITY_DATASET || "pre-prod",
});

export default sanityConfig;
